import React, { ReactElement, useEffect } from 'react';

import { Project } from '@Types/common';

import LoadingIndicator from '@Components/Common/LoadingIndicator/LoadingIndicator';
import ImportOptions from '@Components/NewProjectWizard/ContentWidgets/ImportOptions';
import ImportTasks from '@Components/NewProjectWizard/ContentWidgets/ImportTasks/ImportTasks';
import { FormFilterResponse } from '@Components/NewProjectWizard/Interfaces/PropTypes';
import MultiSelectBox from '@Components/Common/MultiSelectBox/MultiSelectBox';

interface ImportTasksWizzardProps {
    projectData: Project,
    onModalOperationCompletes: () => void | null;
    formFilters: FormFilterResponse;
};
const ImportTasksWizzard = (props: ImportTasksWizzardProps): ReactElement => {

    const { projectData, formFilters, onModalOperationCompletes } = props;
    const [ isLoading, setIsLoading ] = React.useState(false);
    const [ importType, setImportType ] = React.useState<string | undefined>(undefined);
    const [ selectedBaselineId, setSelectedBaselineId ] = React.useState<number | undefined>(undefined);

    const onSelectImportType = (importType: string) => {
        setImportType(importType);
    };

    const onBaselineIdsSelectedChange = (id: number) => {
        setSelectedBaselineId(id);
    };

    useEffect(() => {
        if (formFilters.baselineIdsFilter && formFilters.baselineIdsFilter.length === 1) 
            setSelectedBaselineId(formFilters.baselineIdsFilter[0].id);
    }, [formFilters.baselineIdsFilter]);

    return  <LoadingIndicator isLoading={isLoading} hideWhileLoading={false} isFullScreen={true}>
        <div className='mb-3'>
            <label htmlFor='name' className='title'>
                Baseline
            </label>
            <MultiSelectBox
                name='baselineIdsSelected'
                options={formFilters.baselineIdsFilter ?? []}
                idField='id'
                valueField='name'
                onChange={onBaselineIdsSelectedChange}
                isRequired={true}
                errorMessage='Baselines are required'
                isMulti={false}
                placeholder='Which Baseline should this task be added to?'
                selectedValues={selectedBaselineId?.toString() ?? ''}
            />
        </div>

        { importType === undefined && selectedBaselineId && <ImportOptions onSelectImportType={onSelectImportType} /> }

        {/* Mantaining the state using block/none display style */}
        <div style={{ display: importType ? 'block' : 'none' }}>
            <ImportTasks
                setProjectData={() => onModalOperationCompletes()}
                projectKey={projectData.projectKey}
                setIsLoading={setIsLoading}
                chooseDiffAddTaskMethod={() => setImportType(undefined)}
                importType={importType ?? ''}
                setWizardSubStep={() => {}}
                selectedBaselineId={selectedBaselineId} />
        </div>
    </LoadingIndicator>;
};

export default ImportTasksWizzard;
